import { PrismicDOM } from '../prismic/prismic.service';
var SliceService = /** @class */ (function () {
    function SliceService() {
    }
    SliceService.prototype.parseBody = function (body) {
        return body.map(function (slice) {
            var sliceObj = { type: slice.slice_type, value: null };
            switch (slice.slice_type) {
                case 'text':
                    var html = PrismicDOM.RichText.asHtml(slice.primary.text);
                    if (html.indexOf('<a') > -1) {
                        var c = document.createElement('div');
                        c.innerHTML = html;
                        var as = Array.from(c.querySelectorAll('a'));
                        for (var _i = 0, as_1 = as; _i < as_1.length; _i++) {
                            var a = as_1[_i];
                            a.setAttribute('target', '_blank');
                        }
                        html = c.innerHTML;
                    }
                    sliceObj.value = html;
                    break;
                case 'image':
                    sliceObj.value = slice.primary.image.url;
                    break;
                case 'zevensterbutton':
                    break;
            }
            return sliceObj;
        });
    };
    return SliceService;
}());
export { SliceService };
//# sourceMappingURL=slice.service.js.map